module.exports = __webpack_public_path__ + "img/nav3.37d8b55f.png";